// @ts-ignore
// @ts-nocheck
import { AxiosError } from 'axios';
import { toast } from 'react-toastify';
import api from './api';

type ErrorData = {
  response: {
    data: {
      message: string;
    };
    status: string;
  };
};

export const getUsersAvailable = async (): Promise<null | any> => {
  const userId = localStorage.getItem('@UltragazEmpresarial:userId');

  const headers = {
    access_token: localStorage.getItem('@UltragazEmpresarial:accessToken'),
  };

  try {
    const response = await api.get(
      `/industrial/customer/v1/users/notification?user-id=${userId}&type=EMP`,
      {
        headers,
      }
    );

    return response.data;
  } catch (error) {
    const errorResponse = error as AxiosError | ErrorData;
    if (errorResponse?.response) {
      const { message } = errorResponse.response.data;
      if (message) {
        toast.error(message);
      } else {
        toast.error('Ocorreu um erro interno na aplicação');
      }
    }
  }

  return null;
};

export const putUsersAvailable = async (
  notificationId: string
): Promise<void> => {
  const userId = localStorage.getItem('@UltragazEmpresarial:userId');

  const headers = {
    access_token: localStorage.getItem('@UltragazEmpresarial:accessToken'),
  };
  try {
    await api.put(
      `/industrial/customer/v1/users/notification`,
      {
        notificationId,
        userId,
      },
      {
        headers,
      }
    );
  } catch (error) {
    const errorResponse = error as AxiosError | ErrorData;
    if (errorResponse?.response) {
      const { message } = errorResponse.response.data;
      if (message) {
        toast.error(message);
      } else {
        toast.error('Ocorreu um erro interno na aplicação');
      }
    }
  }
};
